module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/store_images/4_8f110f6099665245886ba854341c9d9d.png";